<!--销售单审核（转采购）-->
<template>
  <div>
    <el-row>
      <el-form :model="searchForm" ref="searchForm" :inline="true">
        <el-col style="margin-top: 20px" :span="24">
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.TC_COMPANY" placeholder="请选择" :clearable="true">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT" @change="querydkList()" placeholder="请选择" clearable multiple>
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
                <span style="float: left">{{ item.PROJECT_NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口：">
            <el-select size="medium" filterable v-model="searchForm.dkName" placeholder="请选择档口" style="width: 100%" clearable>
              <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="状态：">
            <el-select size="medium" filterable v-model="searchForm.STATUS" placeholder="请选择" clearable>
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
                <span style="float: left">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.SEND_DAY" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="handleSearch">筛选</el-button>
          </el-form-item>
        </el-col>
      </el-form>
      <el-col>
        <el-table :data="tableData" border stripe @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户名称"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点名称"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口名称"></el-table-column>
          <el-table-column prop="TOTAL_PROJECT_FEE" label="价格"></el-table-column>
          <el-table-column prop="IS_DISTRIBUTION_CENTER_CHECK" label="状态">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.IS_DISTRIBUTION_CENTER_CHECK == 1">已审核</el-tag>
              <el-tag v-else type="warning">未审核</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" @click="chooseSendDay(scope.row)" v-if="[1,2].includes(scope.row.STATUS)">审核</el-button>
              <el-button type="text" @click="goPrintPreview(scope.row)">打印</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px;">
      <el-col :span="4">
        <el-button class="btn" @click="DateVisible1 = true">批量审核</el-button>
      </el-col>
      <el-col :span="20">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total, prev, pager, next, jumper" :total="totalCount" style="text-align:right"></el-pagination>
      </el-col>
    </el-row>
    <!-- 审核确认模态框 -->
    <el-dialog title="选择日期" center :visible.sync="DateVisible" width="400px" @close="closeDate">
      <el-form v-model="editDateForm" :ref="editDateForm">
        <el-form-item label="选择送货日期：">
          <el-date-picker v-model="editDateForm.SEND_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <el-button @click="closeDate">取 消</el-button>
        <el-button @click="audit" v-preventReClick>确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择日期" center :visible.sync="DateVisible1" width="400px" @close="closeDate">
      <el-form v-model="editDateForm1" :ref="editDateForm1">
        <el-form-item label="选择送货日期：">
          <el-date-picker v-model="editDateForm1.SEND_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <el-button @click="closeDate">取 消</el-button>
        <el-button @click="batchAudit" v-preventReClick :loading="batchAuditLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="以下产品还未配置默认供应商" center :visible.sync="errorVisible" width="50%" @close="closeError">
      <el-table :data="errorList" border>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="产品单位"></el-table-column>
      </el-table>
      <div slot="footer" style="text-align:center">
        <el-button @click="closeError">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  newOrderFun, haveDSXMDFun, selectTCFun,
} from 'api/sellOrder';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
      statusList: [{ label: '未审核', value: '0' }, { label: '已审核', value: '1' }],
      multipleSelection: [],
      currentPage: 1,
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      companys: [],
      points: [{ PROJECT_ID: '', PROJECT_NAME: '' }],
      dkList: [],
      DateVisible: false,
      DateVisible1: false,
      editDateForm: {},
      editDateForm1: {},
      errorVisible: false,
      errorList: [],
      batchAuditLoading: false,
    };
  },
  created() {
    if (this.$store.state.SALESORDERAUDIT) {
      this.searchForm = this.$store.state.SALESORDERAUDIT.CONDITION;
      this.querydkList();
      this.currentPage = this.$store.state.SALESORDERAUDIT.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryCustomer();
  },
  methods: {
    goPrintPreview(row) {
      sessionStorage.setItem('salesOrderAudit', JSON.stringify(row));
      this.$router.push({ name: 'printPreview' });
    },
    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        CHECK_STATUS: 1,
      };
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PROJECT) {
        params.PROJECTS_ID = JSON.parse(JSON.stringify(this.searchForm.PROJECT));
      }
      if (this.searchForm.dkName) {
        params.DK_ID = this.searchForm.dkName;
      }
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.STATUS) {
        params.IS_DISTRIBUTION_CENTER_CHECK = this.searchForm.STATUS;
      }
      newOrderFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.state.SALESORDERAUDIT = {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          };
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    detail(row) {
      this.$router.push({ path: `/salesOrderAuditDetail/${row.ID}`, params: { id: row.ID } });
      sessionStorage.setItem('salesOrderAudit', JSON.stringify(row));
    },
    async audit() {
      if (!this.editDateForm.SEND_DAY) {
        this.$message.show({ text: '请选择送货时间！', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '15064',
        OTYPE: 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.editDateForm.ID,
        SEND_DAY: this.editDateForm.SEND_DAY,
      };
      await http.post(params).then((result) => {
        if (result[0].NONE_SUPPLIER_LIST.length !== 0) {
          this.$message.show({ text: '部分商品未配置默认供应商', type: 'warning' });
          this.errorList = result[0].NONE_SUPPLIER_LIST;
          const temp = new Map();
          this.errorList = this.errorList.filter((item) => !temp.has(item.PRODUCT_CODE) && temp.set(item.PRODUCT_CODE, 1));
          this.errorVisible = true;
        } else {
          this.$message.show({ text: '审核成功', type: 'success' });
        }

        this.queryData();
        this.DateVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },

    batchAudit() {
      if (!this.editDateForm1.SEND_DAY) {
        this.$message.show({ text: '请选择送货时间！', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '15064',
        OTYPE: 5,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID_LIST: this.multipleSelection.map(({ ID }) => ID),
        SEND_DAY: this.editDateForm1.SEND_DAY,
      };

      this.batchAuditLoading = true;

      http.post(params).then((res) => {
        const noneSupplierProductList = [...res[0].NONE_SUPPLIER_LIST];
        if (noneSupplierProductList.length !== 0) {
          this.errorList = noneSupplierProductList;
          const temp = new Map();
          this.errorList = this.errorList.filter((item) => !temp.has(item.PRODUCT_CODE) && temp.set(item.PRODUCT_CODE, 1));
          this.errorVisible = true;
          this.$message.show({ text: '部分商品未配置默认供应商', type: 'warning' });
        } else {
          this.$message.show({ text: '批量审核成功', type: 'success' });
        }
        this.batchAuditLoading = false;

        this.DateVisible1 = false;
        this.multipleSelection = [];
        this.queryData();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.batchAuditLoading = false;
      });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 选择客户
    queryCustomer() {
      selectTCFun()
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].company;
            this.points = result.length > 0 ? result[0].project : [];
          } else {
            this.companys = [];
            this.points = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 获取项目点信息列表
    loadData() {
      haveDSXMDFun()
        .then((result) => {
          this.points = result.length > 0 ? result[0].project : [];
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 下拉框获取档口名称
    querydkList() {
      if (this.searchForm.PROJECT.length === 0) {
        // 当项目点选框为空时，不获取档口名称
        this.dkList = [];
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT) {
        params.PROJECTS_ID = this.searchForm.PROJECT;
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    chooseSendDay(row) {
      this.DateVisible = true;
      this.editDateForm = row;
    },
    closeDate() {
      this.DateVisible = false;
      this.editDateForm = {};
      this.DateVisible1 = false;
      this.editDateForm1 = {};
    },
    closeError() {
      this.errorVisible = false;
      this.errorList = [];
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sendDocument/salesOrderAudit.vue